import React, { useState, useEffect } from "react";
import axios from "axios";
import swal from "sweetalert";
import InputField from "../inputComponents/InputField";
import SelectField from "../inputComponents/SelectField";
import { Link } from "react-router-dom";
import Loading from "../../childComponents/appComponents/Loading";

const ModalPag = (props) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const ADMINNAME = localStorage.getItem("auth_name");

  let categoryName, subCategory, subSubCategory;

  const BUTTON_NAME = "POST FAQ"; // Submit Button Name
  const [buttonClicked, setButtonClicked] = useState(false);
  const [actionType, setActionType] = useState("");
  const [reloadState, setReloadState] = useState({
    btnLoading: props.modalTitle,
    loading: true,
  });

  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };
  //Fetches all Form Data
  const [allformData, setAllFormData] = useState({
    input: {
      status02: null,
      dater: getTodayDate(), // ✅ default today
      linker: null,
    },
    select: {
      position: null,
      triger: null,
      item01: null,
      item02: null,
      item02b: null,
      item03: null,
    },
  });

  const [options, setOptions] = useState({
    positionUse: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
    ],
    position: [],
    triger: [],
    item01: [],
    item02: [],
    item02b: [],
    item03: [],
  });

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setAllFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  //replaces each first character of a word with its uppercase version
  const ucwords = (str) => {
    if (!str) return ""; // handle null/undefined

    str = String(str); // 🔥 force string

    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handleRefresh = () => {
    setButtonClicked(true);
  };

  //   useEffect(() => {
  //     setAllFormData((prev) => ({
  //       ...prev,
  //       input: {
  //         status02: props.editposts.status02,
  //         dater: props.editposts.dater || getTodayDate(),
  //         linker: props.editposts.linker,
  //       },

  //       select: {
  //         position: props.editposts.position || "",
  //         triger: props.editposts.triger || "",
  //         item02b: props.editposts.item02b || "",

  //         item03: props.editposts.item02b
  //           ? props.editposts.item02b
  //           : props.editposts.item02
  //             ? props.editposts.item02
  //             : props.editposts.item01,
  //         item01: props.editposts.item02 && props.editposts.item01,
  //         item02: props.editposts.item02b && props.editposts.item02,
  //       },
  //     }));

  //     setReloadState((prev) => ({
  //       ...prev,
  //       btnLoading: props.modalTitle,
  //       loading: false,
  //     }));

  // (async () => await populateSelectMenu())();

  //   }, [props.editposts, props.modalTitle, buttonClicked]);

  useEffect(() => {
    setAllFormData((prev) => ({
      ...prev,
      input: {
        status02: props.editposts?.status02,
        dater: props.editposts?.dater || getTodayDate(),
        linker: props.editposts?.linker,
      },
      select: {
        position: props.editposts?.position || "",
        triger: props.editposts?.triger || "",
        item02b: props.editposts?.item02b || "",
        item03: props.editposts?.item02b
          ? props.editposts.item02b
          : props.editposts?.item02
            ? props.editposts.item02
            : props.editposts?.item01,
        // item01: props.editposts?.item01 || "",
        // item02: props.editposts?.item02 || "",
        item01: props.editposts?.item02 && props.editposts?.item01,
        item02: props.editposts?.item02b && props.editposts?.item02,
      },
    }));

    setReloadState((prev) => ({
      ...prev,
      btnLoading: props.modalTitle,
      loading: false,
    }));

    populateSelectMenu();
  }, [props.editposts, props.modalTitle]);

  useEffect(() => {
    if (buttonClicked) {
      populateSelectMenu();
      setButtonClicked(false);
    }
  }, [buttonClicked]);

  useEffect(() => {
    (async () => await populateSelectMenu02())();
  }, [allformData.select.item02, allformData.select.item02b]);

  const populateSelectMenu = async () => {
    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(
          `${BASE_URL}inputcomponents?activeStatus[eq]=Active&type[eq]=targetType`,
        ),
        axios.get(
          `${BASE_URL}pagdata?itemName[eq]=menue_tab&status02[eq]=publish&item01[ne]=0&item02[eq]=0&item02b[eq]=0`,
        ),
        axios.get(
          `${BASE_URL}pagdata?itemName[eq]=menue_tab&status02[eq]=publish&item01[ne]=0&item02[ne]=0&item02b[eq]=0`,
        ),
        axios.get(
          `${BASE_URL}pagdata?itemName[eq]=menue_tab&status02[eq]=publish&item01[ne]=0&item02[ne]=0&item02b[ne]=0`,
        ),
        axios.get(`${BASE_URL}catdata`),
      ]);

      const [trigerData, item01Data, item02Data, item02bData, item03Data] =
        responses;

      ////////////////////////////////////////////////////////

      // populate the select menu
      const populateSelect = (colume, columeObject, columeName, values1) => {
        function extractColumn(arr, column, value) {
          return arr.map((x) => ({ item: x[column], values: x[value] }));
        }

        if (columeObject?.data?.status === 200) {
          return setOptions((prev) => ({
            ...prev,
            [colume]: extractColumn(
              columeObject.data.allData,
              columeName,
              values1,
            ),
          }));
        } else if (columeObject?.data?.status === 500) {
          swal("Oops!", columeObject.data.message, "error");
        }
      };

      populateSelect("triger", trigerData, "productCategory", "moreInfo");
      populateSelect("item01", item01Data, "item03", "item01");
      populateSelect("item02", item02Data, "item03", "item02");
      populateSelect("item02b", item02bData, "item03", "item02b");
      populateSelect("item03", item03Data, "webPageName", "id");
    } catch (error) {
      swal("Error", "There were no Data found!", "error");
    }
  };

  const populateSelectMenu02 = async () => {
    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(
          `${BASE_URL}pagdata?itemName[eq]=menue_tab&status02[eq]=publish&item01[eq]=${allformData.select.item02}&item02[ne]=0&item02b[eq]=0`,
        ),
        axios.get(
          allformData.select.item02b
            ? `${BASE_URL}pagdata?itemName[eq]=menue_tab&status02[eq]=publish&item01[ne]=0&item02[eq]=${allformData.select.item02b}&item02b[ne]=0`
            : `${BASE_URL}pagdata?itemName[eq]=menue_tab&status02[eq]=publish&item01[eq]=${allformData.select.item02}&item02[ne]=0&item02b[eq]=0`,
        ),
      ]);

      const [item02Data, item02bData] = responses;

      // populate the select menu
      const populateSelect = (colume, columeObject, columeName, values1) => {
        function extractColumn(arr, column, value) {
          return arr.map((x) => ({ item: x[column], values: x[value] }));
        }

        if (columeObject?.data?.status === 200) {
          return setOptions((prev) => ({
            ...prev,
            [colume]: extractColumn(
              columeObject.data.allData,
              columeName,
              values1,
            ),
          }));
        } else if (columeObject?.data?.status === 500) {
          swal("Oops!", columeObject.data.message, "error");
        }
      };

      populateSelect("item02", item02Data, "item03", "item02");

      //// eleminate all ready used positions  ////
      const usedPositions = item02bData.data.allData.map((item) =>
        item.position?.toString().trim(),
      );

      const filtered = options.positionUse.filter(
        (pos) => !usedPositions.includes(pos),
      );

      setOptions((prev) => ({
        ...prev,
        position: filtered,
      }));
    } catch (error) {
      swal("Error", "There were no Data found!", "error");
    }
  };

  async function submitUpload(event) {
    event.preventDefault();
    setReloadState((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
      loading: true,
    }));

    let urlpost;

    if (props.modalTitle === "POST WEBPAGE") {
      urlpost = `${BASE_URL}pagdata`;
    } else {
      urlpost = `${BASE_URL}pagdata/update`;
    }

    let fileType = 3;

    let formData;

    formData = new FormData();
    if (actionType === "post") {
      formData.append("action", "post");
    }
    if (actionType === "copy") {
      formData.append("action", "copy");
    }
    formData.append("fileType", fileType);

    
    formData.append("item03", ucwords(allformData.select.item03)); // Category

    if ((allformData.select.item01 === 0) || (allformData.select.item01 === null) || (allformData.select.item01 === undefined) || (allformData.select.item01 === "")) {
      formData.append("item01", allformData.select.item02); // Under Main Menu Category
      formData.append("item02", allformData.select.item02b); // Under Drop Down Category
    } else {
      formData.append("item01", allformData.select.item01); // Under Main Menu Category
      formData.append("item02", allformData.select.item02); // Under Drop Down Category
    }

    formData.append("triger", allformData.select.triger || "");
    formData.append("linker", allformData.input.linker || "");

    formData.append("status02", allformData.input.status02 || "");
    formData.append("dater", allformData.input.dater);
    formData.append("position", allformData.select.position);
    formData.append("staff", ADMINNAME);
    formData.append("itemName", "menue_tab");
    formData.append("id", props.editposts.id);

    await axios.get(`sanctum/csrf-cookie`).then((response) => {
      try {
        axios.post(urlpost, formData).then((res) => {
          if (res?.data?.status === 200) {
            swal("Success", res.data.message, "success");
            setReloadState({
              btnLoading: props.modalTitle,
              loading: false,
            });
            props.formCleanners();
            props.setCloseModal(true);
          } else {
            swal("Oops!", res.data.message, "error");
          }
        });
      } catch (error) {
        swal("Oops!", "Failed", "error");
        console.log(error.response.data);
      }
    });
  }
  if (reloadState.loading) {
    return <Loading message01={"Loading..."} />;
  }
  return (
    <>
      <form onSubmit={submitUpload} encType="multipart/form-data">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div
                className={`card-header text-white bg-${props.btnColors} p-3`}
              >
                <i className="fa fa-newspaper"></i> {props.modalTitle}
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <SelectField
                    label="Category Name"
                    name="item03"
                    size="6"
                    placeholder="Select a Category"
                    required="required"
                    value={allformData.select.item03}
                    options={options.item03}
                    type="text"
                    switchOptions={1}
                    onChange={updateFormData}
                    icon="fa fa-file-text"
                  />

                  <SelectField
                    label="Under Main Menu Category"
                    name="item02"
                    size="6"
                    placeholder="Select a Sub Category"
                    required=""
                    value={
                      props.modalTitle === "POST WEBPAGE"
                        ? allformData.select.item02
                        : allformData.select.item01
                    }
                    //value={allformData.select.item01}
                    options={options.item01}
                    type="text"
                    switchOptions={1}
                    onChange={updateFormData}
                    icon="fa fa-file-text"
                  />

                  <SelectField
                    label="Under Drop Down Category"
                    name="item02b"
                    size="6"
                    placeholder="Select a Sub Category"
                    required=""
                    value={
                      props.modalTitle === "POST WEBPAGE"
                        ? allformData.select.item02b
                        : allformData.select.item02
                    }
                    // value={allformData.select.item02}
                    options={options.item02}
                    type="text"
                    switchOptions={1}
                    onChange={updateFormData}
                    icon="fa fa-file-text"
                  />

                  <SelectField
                    label="Position"
                    name="position"
                    size="6"
                    placeholder="Select a Position"
                    required="required"
                    value={allformData.select.position}
                    options={options.position}
                    type="text"
                    switchOptions={0}
                    onChange={updateFormData}
                    icon="fa fa-file-text"
                  />

                  <InputField
                    label="External Address"
                    name="linker"
                    size="6"
                    placeholder="Please Type in an Address Link"
                    required=""
                    value={allformData.input.linker}
                    type="text"
                    onChange={updateFormData}
                    icon="fa fa-file-text"
                  />

                  <SelectField
                    label="External Target Page"
                    name="triger"
                    size="6"
                    placeholder="Select Target Type"
                    required=""
                    value={allformData.select.triger}
                    options={options.triger}
                    type="text"
                    switchOptions={1}
                    onChange={updateFormData}
                    icon="fa fa-file-text"
                  />

                  <InputField
                    label="Start Date"
                    name="dater"
                    size="3"
                    placeholder="Please Select Start Date"
                    required=""
                    value={allformData.input.dater}
                    type="date"
                    onChange={updateFormData}
                    icon="fa fa-calendar-check-o"
                  />

                  <div className="col-lg-3 p-4 row">
                    <InputField
                      label="Save As Draft"
                      size="8"
                      name="status02"
                      type="checkbox"
                      checked={allformData.input.status02 === "draft"}
                      value="draft"
                      onChange={updateFormData}
                    />

                    <InputField
                      label="Publish"
                      size="4"
                      name="status02"
                      type="checkbox"
                      checked={allformData.input.status02 === "publish"}
                      value="publish"
                      onChange={updateFormData}
                    />
                  </div>
                  <div className="row m-1">
                    <div className="col-lg-3 ps-4">
                      <div className="form-group mt-2">
                        <button
                          className={`btn btn-${props.btnColors} col-lg-12 mt-4`}
                          onClick={() => setActionType("post")}
                        >
                          <div className="d-flex align-items-center justify-content-center w-100">
                            <i className="fa fa-edit m-1"></i>
                            <span>{reloadState.btnLoading}</span>
                          </div>
                        </button>
                      </div>
                    </div>

                    <div className="col-lg-3 ps-4">
                      <div className="form-group mt-2">
                        <button
                          className={`btn btn-secondary col-lg-12 mt-4`}
                          onClick={() => setActionType("copy")}
                        >
                          <div className="d-flex align-items-center justify-content-center w-100">
                            <i className="fa fa-clone m-1"></i>
                            <span>COPY POST</span>
                          </div>
                        </button>
                      </div>
                    </div>

                    <div className="col-lg-3 ps-4">
                      <div className="form-group mt-2">
                        <Link
                          className={`btn btn-danger col-lg-12 mt-4`}
                          onClick={handleRefresh}
                        >
                          <div className="d-flex align-items-center justify-content-center w-100">
                            <i className="fa fa-refresh m-1"></i>
                            <span>REFRESH</span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};
export default ModalPag;
